import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from '../../assets/images/cards/slotPage/card-1.jpg'
import img2 from '../../assets/images/cards/slotPage/card-2.jpg'
import img3 from '../../assets/images/cards/slotPage/card-3.jpg'
import img4 from '../../assets/images/cards/slotPage/card-4.jpg'
import img5 from '../../assets/images/cards/slotPage/card-5.jpg'
import img6 from '../../assets/images/cards/slotPage/card-6.jpg'
import img7 from '../../assets/images/cards/slotPage/card-7.jpg'
import img8 from '../../assets/images/cards/slotPage/card-8.jpg'
import img9 from '../../assets/images/cards/slotPage/card-9.jpg'
import img10 from '../../assets/images/cards/slotPage/card-10.jpg'
import img11 from '../../assets/images/cards/slotPage/card-11.jpg'
import img12 from '../../assets/images/cards/slotPage/card-12.jpg'
import img13 from '../../assets/images/cards/slotPage/card-13.jpg'
import img14 from '../../assets/images/cards/slotPage/card-14.jpg'
import img15 from '../../assets/images/cards/slotPage/card-15.jpg'
import img16 from '../../assets/images/cards/slotPage/card-16.jpg'
import img17 from '../../assets/images/cards/slotPage/card-17.jpg'
import img18 from '../../assets/images/cards/slotPage/card-18.jpg'
import img19 from '../../assets/images/cards/slotPage/card-19.jpg'
import img20 from '../../assets/images/cards/slotPage/card-20.jpg'
import img21 from '../../assets/images/cards/slotPage/card-21.jpg'
import img22 from '../../assets/images/cards/slotPage/card-22.jpg'
import img23 from '../../assets/images/cards/slotPage/card-23.jpg'
import img24 from '../../assets/images/cards/slotPage/card-24.jpg'

export const SlotPageDB = [
  {
    title:'777 Oktoberfest',
    image:img1
  },
  {
    title:'Aztec Magic',
    image:img2
  },
  {
    title:'Book of dead',
    image:img3
  },
  {
    title:'coinfest',
    image:img4
  },
  {
    title:'777 Oktoberfest',
    image:img5
  },
  {
    title:'777 Oktoberfest',
    image:img6
  },
  {
    title:'Green Machine Supreme',
    image:img7
  },
  {
    title:'Tropical Bonanza',
    image:img8
  },
  {
    title:'Moon princess',
    image:img9
  },
  {
    title:'benny biggest game',
    image:img10
  },
  {
    title:'wolf power',
    image:img11
  },
  {
    title:'book of poseidon',
    image:img12
  },
  {
    title:'Moon princess',
    image:img13
  },
  {
    title:'benny biggest game',
    image:img14
  },
  {
    title:'wolf power',
    image:img15
  },
  {
    title:'book of poseidont',
    image:img16
  },
  {
    title:'Moon princess',
    image:img17
  },
  {
    title:'benny biggest game',
    image:img18
  },
  {
    title:'wolf power',
    image:img19
  },
  {
    title:'book of poseidon',
    image:img20
  },
  {
    title:'Moon princess',
    image:img21
  },
  {
    title:'benny biggest game',
    image:img22
  },
  {
    title:'wolf power',
    image:img23
  },
  {
    title:'book of poseidon',
    image:img24
  },

]